import React, {Component} from "react";
import { Link } from 'react-router-dom'
import API from "../config/api";
import moment from 'moment';

class Dashboard extends Component {
  
  state = {
    total_questions : 0,
    total_categories: 0,
    total_users: 0,
    images: [],
    blind_test: [],
    sounds: [],
    total_size: '',
    data: ''
  }
  
  componentDidMount() {
    // window.location.href = 'questionindex'
    this.getAllQuestions();
    this.getAllCategories();
    this.getAllUsers();
    this.getStorageInfo();
  }

  getStorageInfo = async () => {
    try {
      // let query = `page=${this.state.page}`
      let results = await API.getStorageInfo();

      let data = results.data;
      
      this.setState({ images: data.images, blind_test: data.blind_test, sounds: data.sounds, total_size: data.total_file_size, data: data.date });

    } catch (error) {
      console.log(error)
    }
  }

  getAllQuestions = async () => {
    try {
      // let query = `page=${this.state.page}`
      let results = await API.getAllQuestions();

      let data = results.data.result;
      
      this.setState({ total_questions: data.total });
      // this.setState({ users : data.users, total: data.total, limit: data.limit  });

    } catch (error) {
      console.log(error)
    }
  }

  getAllCategories = async () => {
    try {
      // let query = `page=${this.state.page}`
      let results = await API.getAllCategory();
      let data = results.data;
      
      this.setState({ total_categories: data.total });

    } catch (error) {
      console.log(error)
    }
  }

  getAllUsers = async () => {
    try {
      // let query = `page=${this.state.page}&s=${this.state.s}`
      let results = await API.getAllUsers();

      let data = results.data.result;
      
      this.setState({ total_users: data.total });

    } catch (error) {
      console.log(error)
    }
  }
  

  getDay(i) {
    return moment().subtract(i, 'day').format("DD")
  }

  render() {
    return (
      <div className="col-12 ">
        <div className="row ">
            <div class="col-md-6 col-xl-4">
              <div class="card card-body">
              <h6>
              <span class="text-uppercase">Total Users </span>
              <span class="float-right"><Link class="btn btn-xs btn-primary" to="/userindex">View</Link></span>
              </h6>
              <br />
              <p class="fs-28 fw-100"><span className="fa fa-user"></span> {this.state.total_users}</p>

                <div class="progress">
                  <div class="progress-bar bg-success" role="progressbar" style={{width: "100%", height: "4px"}} aria-valuenow="35" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                {/* <div class="text-gray fs-12"><i class="ti-stats-down text-success mr-1"></i> %18 decrease from last month</div> */}
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="card card-body">
                <h6>
                  <span class="text-uppercase">Total Questions</span>
                  <span class="float-right"><Link class="btn btn-xs btn-primary" to="/questionindex">View</Link></span>
                </h6>
                <br />
                <p class="fs-28 fw-100"><span className="fa fa-question"></span> {this.state.total_questions}</p>
                <div class="progress">
                  <div class="progress-bar bg-warning" role="progressbar" style={{width: "100%", height: "4px"}} aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                {/* <div class="text-gray fs-12"><i class="ti-stats-up text-success mr-1"></i> 324 more than last year</div> */}
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="card card-body">
                <h6>
                  <span class="text-uppercase">Total Categories</span>
                  <span class="float-right"><Link class="btn btn-xs btn-primary" to="/categoryindex">View</Link></span>
                </h6>
                <br />
                <p class="fs-28 fw-100"><span class="fa fa-tasks"></span> {this.state.total_categories}</p>
                <div class="progress">
                  <div class="progress-bar " role="progressbar" style={{width: "100%", height: "4px"}} aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                {/* <div class="text-gray fs-12"><i class="ti-arrow-down text-danger mr-1"></i> %32 down</div> */}
              </div>
            </div>

            </div>

            <div className="row ">
            <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="flexbox">
                  <h5>Image</h5>
                  
                </div>
                <div class="text-center my-2">
                  <div class="fs-60 fw-400 text-info">{this.state.images.nb_files}</div>
                  <span class="fw-400 text-muted">Files</span>
                </div>
              </div>

              <div class="card-body bg-lighter fw-400 py-12">
                <span class="text-muted mr-1">Size:</span>
                <span class="text-dark">{this.state.images.total_size}</span>
              </div>

              <div class="progress mb-0">
                <div class="progress-bar bg-info" role="progressbar" style={{width: "100%", height: '3px'}} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>




          <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="flexbox">
                  <h5>Blind Test</h5>
                  
                </div>

                <div class="text-center my-2">
                  <div class="fs-60 fw-400 text-danger">{this.state.blind_test.nb_files}</div>
                  <span class="fw-400 text-muted">Files</span>
                </div>
              </div>

              <div class="card-body bg-lighter fw-400 py-12">
                <span class="text-muted mr-1">Size</span>
                <span class="text-dark">{this.state.blind_test.total_size}</span>
              </div>

              <div class="progress mb-0">
                <div class="progress-bar bg-danger" role="progressbar" style={{width: "100%", height: '3px'}} aria-valuenow="35" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>



          <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="flexbox">
                  <h5>Sound</h5>
                  
                </div>

                <div class="text-center my-2">
                  <div class="fs-60 fw-400 text-primary">{this.state.sounds.nb_files}</div>
                  <span class="fw-400 text-muted">Files</span>
                </div>
              </div>

              <div class="card-body bg-lighter fw-400 py-12">
                <span class="text-muted mr-1">Size</span>
                <span class="text-dark">{this.state.sounds.total_size}</span>
              </div>

              <div class="progress mb-0">
                <div class="progress-bar" role="progressbar" style={{width: "100%", height: '3px'}} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>



          <div class="col-md-6 col-xl-3">
            <div class="card">
              <div class="card-body">
                <div class="flexbox">
                  <h5>Total</h5>
                  
                </div>

                <div class="text-center my-2">
                  <div class="fs-60 fw-400 text-dark">{parseFloat(this.state.total_size)}</div>
                  {/* <div class="fs-60 fw-400 text-dark">{this.state.total_size}</div> */}
                  <span class="fw-400 text-muted">MB</span>
                  <br />
                </div>
              </div>

              <div class="card-body bg-lighter fw-400 py-12">
                <span class="text-muted mr-1">Date:</span>
                <span class="text-dark" > {this.state.data}</span>
              </div>

              <div class="progress mb-0">
                <div class="progress-bar bg-dark" role="progressbar" style={{width: "100%", height: '3px'}} aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>
              
            </div>  


        </div>
        
    );
  }
}



export default Dashboard;

{/* <div class="col-md-6 col-xl-3">
                  <div class="card">
                    <div class="card-body">
                      <div class="flexbox">
                        <h5>Tasks</h5>
                        <div class="dropdown">
                          <span class="dropdown-toggle no-caret" data-toggle="dropdown"><i class="ti-more-alt rotate-90"></i></span>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" href="#"><i class="ion-android-list"></i> Details</a>
                            <a class="dropdown-item" href="#"><i class="ion-android-add"></i> Add new</a>
                            <a class="dropdown-item" href="#"><i class="ion-android-refresh"></i> Refresh</a>
                          </div>
                        </div>
                      </div>
    
                      <div class="text-center my-2">
                        <div class="fs-60 fw-400 text-info">34</div>
                        <span class="fw-400 text-muted">Due Tasks</span>
                      </div>
                    </div>
    
                    <div class="card-body bg-lighter fw-400 py-12">
                      <span class="text-muted mr-1">Completed:</span>
                      <span class="text-dark">16</span>
                    </div>
    
                    <div class="progress mb-0">
                      <div class="progress-bar bg-info" role="progressbar" style={{width: "45%", height: '3px'}} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div> */}
